import React, { useMemo } from 'react'

import { useBufferMap } from '../../buffers/hooks'
import { useEsri } from '../hooks'

import GraphicLayer from './GraphicLayer'

const symbol = {
  type: 'simple-fill',
  color: [51, 51, 204, 0.5],
  style: 'solid',
  ouline: {
    width: 1,
    style: 'short-dash',
    color: [0, 0, 200, 0.8]
  }
}

const getIncidentCenter = incident => ({
  x: incident.longitude,
  y: incident.latitude,
  spatialReference: { wkid: 4326 }
})

const esriReqs = ['esri/geometry/Circle']

const BufferLayer = ({ map, view }) => {
  const [buffer, incident] = useBufferMap()
  const [ready, { Circle }] = useEsri(esriReqs)

  const graphics = useMemo(() => {
    if (!ready || buffer === null || incident === null) return []

    return [
      {
        geometry: new Circle({
          center: getIncidentCenter(incident),
          radius: buffer.distance,
          radiusUnit: buffer.unit
        }),
        symbol,
        attributes: { ...incident, ...buffer }
      }
    ]
  }, [ready, Circle, buffer, incident])

  return (
    <GraphicLayer id="BufferLayer" map={map} view={view} graphics={graphics} />
  )
}

export default BufferLayer
